module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-container",
    on: {
      "click": _vm.wrapperClicked
    }
  }, [_vm._t("default"), _vm._v(" "), _c('input', {
    attrs: {
      "multiple": _vm.multiple,
      "type": "file"
    },
    on: {
      "change": _vm.emitChanges
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ff903c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/UploadWrapper.vue
// module id = 2576
// module chunks = 1